export default __webpack_public_path__ + "static/media/foto8.84401b3d.jpg";